export const PRODUCTS_QUALITIES = "PRODUCTS_QUALITIES";
export const PRODUCTS_QUALITIES_ALL = "PRODUCTS_QUALITIES_ALL";
export const PRODUCT_QUALITIES_SELECT_CHANGEVALUE =
	"PRODUCT_QUALITIES_SELECT_CHANGEVALUE";

export const PRODUCT_QUALITIES_CHANGEVALUE = "PRODUCT_QUALITIES_CHANGEVALUE";
export const PRODUCT_QUALITIES_UNITS_VALUE = "PRODUCT_QUALITIES_UNITS_VALUE";
export const PRODUCT_QUALITIES_VENDORS_VALUE =
	"PRODUCT_QUALITIES_VENDORS_VALUE";

export const PRODUCT_QUALITIES_GROUP_VALUE = "PRODUCT_QUALITIES_GROUP_VALUE";
export const GET_PRODUCT_QUALITIES_ROW_DATA = "GET_PRODUCT_QUALITIES_ROW_DATA";
export const PRODUCT_QUALITIES_ADD = "PRODUCT_QUALITIES_ADD";
export const PRODUCT_QUALITIES_ADD_SUCCESSFUL =
	"PRODUCT_QUALITIES_ADD_SUCCESSFUL";
export const PRODUCT_QUALITIES_ROW_SUCCESSFUL =
	"PRODUCT_QUALITIES_ROW_SUCCESSFUL";
export const GROUP_CHANGEVALUE = "GROUP_CHANGEVALUE";
export const PRODUCT_QUALITIES_GROUPS = "PRODUCT_QUALITIES_GROUPS";
export const PRODUCT_QUALITIES_GROUP_LIST_SUCCESSFUL =
	"PRODUCT_QUALITIES_GROUP_LIST_SUCCESSFUL";
export const PRODUCT_QUALITIES_DELETE = "PRODUCT_QUALITIES_DELETE";
export const MODEL_OPEN = "MODEL_OPEN";
export const MODEL_CLOSE = "MODEL_CLOSE";
export const PRODUCT_QUALITIES_LIST_SUCCESSFUL =
	"PRODUCT_QUALITIES_LIST_SUCCESSFUL";
export const SET_PARAMS = "SET_PARAMS";
export const API_ERROR = "API_ERROR";

export const UNITS_MODEL_OPEN = "UNITS_MODEL_OPEN";
export const UNITS_MODEL_CLOSE = "UNITS_MODEL_CLOSE";
export const UNITS_CHANGEVALUE = "UNITS_CHANGEVALUE";
export const DELETE_UNITS_ROW = "DELETE_UNITS_ROW";

export const MR_CUSTOM_PRODUCT_QUALITIES = "MR_CUSTOM_PRODUCT_QUALITIES";

export const PRODUCT_QUALITY_EDIT = "PRODUCT_quality_edit";
export const PRODUCT_QUALITY_EDIT_SUCCESSFUL =
	"PRODUCT_quality_edit_successfull";
export const PRODUCT_QUALITY_SETROWDATA = "PRODUCT_quality_set_rowdata";
